import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ADMIN_CONFIGURATION } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { fg } from '@confluence/feature-gating';

const AdminConfluenceChatsIntegrationComponent = LoadableAfterPaint({
	loader: async () =>
		import(
			/* webpackChunkName: "loadable-AdminConfluenceChatsIntegrationComponent" */ './AdminConfluenceChatsIntegrationComponent.tsx'
		),
});

export const AdminConfluenceChatsIntegrationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (!fg('twcg-2215-confluence-chats-integration-migration')) {
		return <Redirection name={ADMIN_CONFIGURATION.name} />;
	}

	return <AdminConfluenceChatsIntegrationComponent />;
};

AdminConfluenceChatsIntegrationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'adminConfluenceChatsIntegrationScreen',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
